import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { store } from "@/commonui/store/index";

@Module({ namespaced: true, name: "spinner", store: store, dynamic: true })
class Spinner extends VuexModule {
	public maskMain = false;
	public maskView = false;
	public splash = false;

	@Mutation
	async setMaskMain(value: boolean) {
		this.maskMain = value;
	}

	@Mutation
	async setMaskView(value: boolean) {
		this.maskView = value;
	}

	@Mutation
	setSplash(value: boolean): void {
		this.splash = value;
	}
}

export { Spinner };
